export default __webpack_public_path__ + "static/media/activalogo3.b7ac3a6e.png";